import { defineStore } from 'pinia';
import { API_URL, authFetch } from '../api';

export const useSnapshotStore = defineStore('snapshots', {
    state: () => ({
      snapshots: [],
      loading: false,
      error: null,
    }),
    actions: {
        async addBatchSnapshot(snapshotData) {
            try {
              // Ensure we get the correct date regardless of timezone
              const date = new Date(snapshotData.date);
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');
              
              // Filter out accounts with no balance set
              const filteredSnapshots = Object.entries(snapshotData.balances)
                .filter(([,balance]) => balance !== null && balance !== undefined)
                .map(([accountId, balance]) => ({
                  account_id: parseInt(accountId),
                  balance: Number(balance),
                  comment: snapshotData.comments[accountId] || null
                }));
          
              const transformedData = {
                date: `${year}-${month}-${day}`,
                snapshots: filteredSnapshots
              };
          
              const response = await authFetch(`${API_URL}/snapshots/batch`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify(transformedData),
              });
          
              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }
          
              return await response.json();
            } catch (error) {
              this.error = error;
              throw error;
            }
        }
    }
});